/** @format */

import {
    PROOF_STATUS_PENDING,
    METHOD_NET30,
    PROOF_TYPE_PRINTED,
    PROOF_INTERNAL_COMPLETE
} from 'frontier-constants';
import {If} from 'frontier-utilities';
import React from 'react';

// stylea
import './invoice_id_column.scss';

export const InvoiceIdColumn = props => {
    const {cart} = props;

    // are there any pending charges?
    const pendingCharges = cart.charge_batches.filter(
        ({total, is_complete}) => is_complete === false && total > 0
    );

    // are there any pending proofs?
    const pendingProofs = cart.orders
        .map(order => {
            return order.proofs.filter(proof => {
                if (
                    parseInt(proof.type_id) === PROOF_TYPE_PRINTED &&
                    parseInt(proof.internal_status) !== PROOF_INTERNAL_COMPLETE
                )
                    return false;
                if (proof.status_id === PROOF_STATUS_PENDING) return true;
            });
        })
        .flat();

    // are there any invoices?
    const isPendingInvoice =
        !cart.is_paid && parseInt(cart.billing_method_id) === METHOD_NET30 && cart.is_shipped;
    const pendingInvoice = isPendingInvoice ? 1 : 0;

    const totalAttentionItems = pendingCharges.length + pendingProofs.length + pendingInvoice;
    const rowNeedsAttention = totalAttentionItems > 0;
    return (
        <div className="orders-list-table-active-31cs__column--invoice">
            <b>{cart.id}</b>
            <If condition={!!cart.po_number}>
                <b className="font-is-set orders-list-table-active-31cs__column--invoice-po color-structure-darker">
                    PO: {cart.po_number}
                </b>
            </If>
            <If condition={rowNeedsAttention}>
                <span className="column-31cs__pending-items d-flex align-items-center justify-content-start">
                    <i className="fa fa-warning me-2" />
                    <b>Needs Attention ({totalAttentionItems})</b>
                </span>
            </If>
        </div>
    );
};
